import { Box, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";

export default function InfoStep01() {

  const { getValues } = useFormContext()
  const { identificacao } = getValues()
  
  return (
    <>
      <Typography  mb={0.5} variant="subtitle1">{identificacao.publico_dado.tipo_publico}{identificacao.publico_dado.codigo_publico} - {identificacao.publico_dado.nome_pessoa}</Typography>
      <Box display={'flex'} gap={4}>
          <TableView
          title="Código"
          text={`${identificacao.tipo_documento.id}-${identificacao.numero_documento}`}
          />
          <TableView
          title="Categoria"
          text={`${identificacao.categoria.id}-${identificacao.categoria.nome}`}
          />
      </Box>
    </>

  )
}

function TableView({ title, text }:TableViewProps) {
  return (
    <Box mb={1}>
      <Typography variant="subtitle2" color="textSecondary">
        {title}
      </Typography>
      <Typography variant="subtitle1">
        {text}
      </Typography>
    </Box>
  );
}

interface TableViewProps {
  title: string;
  text: string;
}